"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
var format_activity_type_1 = require("./format-activity-type");
var format_language_1 = require("./format-language");
var format_options_1 = require("./format-options");
var format_steps_1 = require("./format-steps");
var format_text_audio_parts_1 = require("./format-text-audio-parts");
var format_url_1 = require("./format-url");
var pipeTwo = function (f, g) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return g(f.apply(void 0, args));
}; };
var pipe = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduce(pipeTwo);
};
var format = function (data, language, assetBaseUrl) {
    var formatObj = pipe(format_activity_type_1.formatActivityType, function (data) { return (0, format_url_1.formatUrl)(data, assetBaseUrl); }, format_text_audio_parts_1.formatTextAudioParts, function (data) { return (0, format_language_1.formatLanguage)(data, language); }, format_options_1.formatOptions, format_steps_1.formatSteps);
    return formatObj(data);
};
exports.format = format;
